module.exports = __webpack_public_path__ + "20260128d142218t/img/ewm2.25bff2fe.png";